import AppBar from '@/components/appBar';
import Button from '@/components/button';
import Page from '@/components/page';
import React, { useState } from 'react';
import PayOrderListPage from '../payOrder/payOrderListPage';
import PackOrderListPage from '../packOrderListPage';
import IncomeListPage from '../incomeListPage';
interface Props {}

// {
//   label: '我的订单',
//   url: '/pay-order-list',
//   img: '/pic/orders.png',
// },
// {
//   label: '套餐记录',
//   url: '/pack-order-list',
//   img: '/pic/package.png',
// },
// {
//   label: '消费记录',
//   url: '/income-list',
//   img: '/pic/Recording.png',
// },
const orderList = 'orderList';
const packOrderList = 'packOrderList';
const incomeList = 'incomeList';
export default function IncomeInfo({}: Props) {
  const [type, setType] = useState(orderList);
  return (
    <Page className="d-flex-c bg-gray" contentClassName="flex-1 d-flex-c h-1" appBar={<AppBar title="消费明细" />}>
      <div className="d-flex-r ai-center jc-between pt-10 pb-10 pl-20 pr-20">
        <Button
          type={type === orderList ? 'primary' : 'default'}
          className="minw-80"
          onClick={() => setType(orderList)}
        >
          我的订单
        </Button>
        <Button
          type={type === packOrderList ? 'primary' : 'default'}
          className="minw-80"
          onClick={() => setType(packOrderList)}
        >
          套餐记录
        </Button>
        <Button
          type={type === incomeList ? 'primary' : 'default'}
          className="minw-80"
          onClick={() => setType(incomeList)}
        >
          消费记录
        </Button>
      </div>
      <div className="flex-1 h-1">
        {type === orderList && <PayOrderListPage hideAppBar={true} />}
        {type === packOrderList && <PackOrderListPage hideAppBar={true} />}
        {type === incomeList && <IncomeListPage hideAppBar={true} />}
      </div>
    </Page>
  );
}
